/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2022 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { HYDRATE } from "next-redux-wrapper";
import * as Redux from "redux";

import globalUI, { GlobalUIState } from "src/store/modules/globalUI";

import search, { SearchState } from "./modules/search";

export interface AppState {
  search: SearchState;
  globalUI: GlobalUIState;
}

const appReducer = Redux.combineReducers({
  search,
  globalUI,
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const rootReducer = (state: any, action: any): AppState => {
  if (action.type === "RESET_APP") {
    state = undefined;
  } else if (action.type === HYDRATE) {
    return ssrHydrateRedux(state, action);
  }
  return appReducer(state, action);
};

/**
 * Hydrate client store with server-side store
 *
 * It will only happen on /plate route and will include user data and activePage data
 */
function ssrHydrateRedux(state: any, action: any): AppState {
  return {
    ...state,
    globalUI: {
      ...state.globalUI,
      uiSettings: {
        ...state.globalUI.uiSettings,
        isScreenshotter: action.payload.globalUI.uiSettings.isScreenshotter || false,
      },
    },
  };
}
